import React from 'react';
export function Disclaimer() {
  return <footer className="bg-stone-900 text-stone-500 py-12 px-4 text-sm text-center" data-id="element-92">
      <div className="max-w-3xl mx-auto space-y-6" data-id="element-93">
        <p className="leading-relaxed" data-id="element-94">
          Este producto es educativo y de organización. No reemplaza consejo
          médico ni tratamiento profesional. Si tomás medicación o tenés una
          condición de salud, consultá con tu médico ante cambios importantes en
          tu alimentación.
        </p>
        <div className="h-px w-12 bg-stone-800 mx-auto" data-id="element-95"></div>
        <p data-id="element-96">© 2026 Semana Resuelta. Todos los derechos reservados.</p>
      </div>
    </footer>;
}